import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useLogout from './hooks/useLogout';

declare module '@stackflow/config' {
    interface Register {
        LogoutModal: {};
    }
}

const LogoutModal: ActivityComponentType<'LogoutModal'> = () => {
    const { t } = useTranslation('accountSetting');
    const { pop } = useFlow();
    const logout = useLogout();
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth align='center' spacing={28}>
                    <Column spacing={8} align='center'>
                        <Text size='2xl' fontWeight='bold'>
                            {t('logoutModal.title')}
                        </Text>
                        <Text size='lg'>{t('logoutModal.message')}</Text>
                    </Column>
                    <Row fullWidth spacing={10}>
                        <Button onClick={pop}
                            fullWidth
                            variant='secondary'
                            size='sm'
                            noPadding >
                            {t('logoutModal.cancel')}
                        </Button>
                        <Button size='sm' onClick={logout} fullWidth noPadding>
                            {t('logoutModal.confirm')}
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default LogoutModal;
